import { render, staticRenderFns } from "./PracticeSumupEdit.vue?vue&type=template&id=7487a7ea&scoped=true&"
import script from "./PracticeSumupEdit.vue?vue&type=script&lang=ts&"
export * from "./PracticeSumupEdit.vue?vue&type=script&lang=ts&"
import style0 from "./PracticeSumupEdit.vue?vue&type=style&index=0&id=7487a7ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7487a7ea",
  null
  
)

export default component.exports